import React from 'react';

const ProgressBar = ({ value, max, label, showPercentage = true }) => {
  const percentage = max > 0 ? Math.round((value / max) * 100) : 0;
  
  return (
    <div className="w-full">
      <div className="flex justify-between items-end mb-2">
        {label && <span className="text-sm font-medium text-espresso-light">{label}</span>}
        {showPercentage && <span className="text-xs font-bold text-terracotta">{percentage}%</span>}
      </div>
      <div className="h-2 w-full bg-cream-dark rounded-full overflow-hidden">
        <div 
          className="h-full bg-sage transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;